// extracted by mini-css-extract-plugin
module.exports = {"dialog":"EntityForm--dialog","content":"EntityForm--content"};